import React from "react";
import Tooltip from "@mui/material/Tooltip";

const TruncatedTextWithTooltip = ({
  text = "",
  children,
  className = "",
  maxWidth = "100%",
  lines = 1,
}) => {
  const textRef = React.useRef(null);
  const [isTruncated, setIsTruncated] = React.useState(false);

  React.useEffect(() => {
    const el = textRef.current;
    if (el) {
      const isOverflowing =
        el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
      setIsTruncated(isOverflowing);
    }
  }, [text, children]);

  const isMultiLine = lines > 1;

  const styles = {
    display: isMultiLine ? "-webkit-box" : "block",
    WebkitLineClamp: isMultiLine ? lines : undefined,
    WebkitBoxOrient: isMultiLine ? "vertical" : undefined,
    whiteSpace: isMultiLine ? "normal" : "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth,
    cursor: "inherit",
  };

  return (
    <Tooltip title={isTruncated ? text : ""}>
      <div ref={textRef} className={className} style={styles}>
        {children || text}
      </div>
    </Tooltip>
  );
};

export default TruncatedTextWithTooltip;
